import { createSlice } from '@reduxjs/toolkit';

const countdownSlice = createSlice({
  name: 'countdown',
  initialState: {
    disableButton: false,
    status: '',
  },
  reducers: {
    disableButton: (state) => {
      state.disableButton = true;
    },
    activeButton: (state) => {
      state.disableButton = false;
    },
  },
});
export const { disableButton, activeButton } = countdownSlice.actions;
export default countdownSlice.reducer;
